import * as actions from './action';
import * as mutations from './mutations';
import * as queries from './queries';

export function fetchMachineDetailsInformation(id) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.GET_MACHINE_DETAILS_INFORMATION_REQUEST });
      const clientResponse = await client.query({
        query: queries.getMachineDetailsInformation,
        variables: {
          id
        }
      });
      const result = clientResponse?.data?.getMachine;
      dispatch({
        type: actions.GET_MACHINE_DETAILS_INFORMATION_SUCCESS,
        payload: result
      });
    } catch (error) {
      dispatch({
        type: actions.GET_MACHINE_DETAILS_INFORMATION_FAIL,
        payload: { error }
      });
    }
  };
}

export function updateMachineField(id, patch) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.UPDATE_MACHINE_DETAILS_REQUEST });
      const clientResponse = await client.mutate({
        mutation: mutations.updateMachine,
        variables: {
          input: {
            id,
            patch
          }
        }
      });

      const payload = clientResponse?.data?.updateMachine;

      dispatch({
        type: actions.UPDATE_MACHINE_DETAILS_SUCCESS,
        payload
      });
    } catch (error) {
      dispatch({
        type: actions.UPDATE_MACHINE_DETAILS_FAIL,
        payload: { error }
      });
    }
  };
}

export function fetchMachineSuggestions() {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.LIST_MACHINE_SUGGESTION_REQUEST });
      const clientResponse = await client.query({
        query: queries.listMachineSuggestedFieldValues
      });

      const payload = clientResponse?.data?.listMachineSuggestedFieldValues;

      dispatch({
        type: actions.LIST_MACHINE_SUGGESTION_SUCCESS,
        payload
      });
    } catch (error) {
      dispatch({
        type: actions.LIST_MACHINE_SUGGESTION_FAIL,
        payload: { error }
      });
    }
  };
}

export function deleteMachine(id) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.DELETE_MACHINE_REQUEST });
      await client.mutate({
        mutation: mutations.deleteMachine,
        variables: {
          input: {
            id
          }
        }
      });
      dispatch({
        type: actions.DELETE_MACHINE_SUCCESS,
        payload: id
      });
    } catch (error) {
      dispatch({
        type: actions.DELETE_MACHINE_FAIL
      });
    }
  };
}

export function updateMachineGeofence(id, patch) {
  return async (dispatch, _, { client }) => {
    try {
      dispatch({ type: actions.UPDATE_MACHINE_GEOFENCE_REQUEST });
      const clientResponse = await client.mutate({
        mutation: mutations.updateMachine,
        variables: {
          input: {
            id,
            patch
          }
        }
      });

      const payload = clientResponse?.data?.updateMachine;

      dispatch({
        type: actions.UPDATE_MACHINE_GEOFENCE_SUCCESS,
        payload
      });
    } catch (error) {
      dispatch({
        type: actions.UPDATE_MACHINE_GEOFENCE_FAIL,
        payload: { error }
      });
    }
  };
}
